import { motion } from "motion/react"
import { cn } from "@/utils/cn"

export function HighlightAnimatedSvg({
  animate,
  className,
}: {
  animate: boolean
  className?: string
}) {
  return (
    <motion.svg
      viewBox="0 0 656 885"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      stroke="#FFFAF4"
      strokeWidth="3"
      strokeLinecap="round"
      className={cn(
        "bg-radial from-viola-500 to-transparent to-70% lg:h-[80rem] lg:w-[65rem]",
        className
      )}
      initial={{ opacity: 0, scale: 0 }}
      animate={{ opacity: animate ? 1 : 0, scale: animate ? 1 : 0.6 }}
      transition={{
        duration: 0.5,
      }}
    >
      <motion.path
        d="M373.989 138.706C370.302 93.7173 376.802 47.0187 379.35 2"
        initial={{ pathLength: 0 }}
        animate={{ pathLength: animate ? 1 : 0 }}
        transition={{ duration: 0.1, delay: 0.2, ease: "easeInOut" }}
      />
      <motion.path
        d="M10.0234 177.863C50.8269 219.314 85.629 267.153 122.605 311.889"
        initial={{ pathLength: 0 }}
        animate={{ pathLength: animate ? 1 : 0 }}
        transition={{ duration: 0.1, delay: 0.3, ease: "easeInOut" }}
      />
      <motion.path
        d="M117.244 604.065C82.8521 633.383 45.8712 659.694 10.0234 687.161"
        initial={{ pathLength: 0 }}
        animate={{ pathLength: animate ? 1 : 0 }}
        transition={{ duration: 0.1, delay: 0.4, ease: "easeInOut" }}
      />
      <motion.path
        d="M382.618 740.771C374.005 787.715 371.374 835.417 366.535 882.839"
        initial={{ pathLength: 0 }}
        animate={{ pathLength: animate ? 1 : 0 }}
        transition={{ duration: 0.1, delay: 0.5, ease: "easeInOut" }}
      />
      <motion.path
        d="M177.688 66.0527C179.251 72.3081 184.285 80.8329 186.738 86.019C193.592 100.511 199.732 115.233 206.237 129.87"
        initial={{ pathLength: 0 }}
        animate={{ pathLength: animate ? 1 : 0 }}
        transition={{ duration: 0.1, delay: 0.6, ease: "easeInOut" }}
      />
      <motion.path
        d="M540.438 715.981C559.125 743.178 578.61 769.155 599.217 794.913"
        initial={{ pathLength: 0 }}
        animate={{ pathLength: animate ? 1 : 0 }}
        transition={{ duration: 0.1, delay: 0.7, ease: "easeInOut" }}
      />
      <motion.path
        d="M228.068 719.34C207.81 755.108 187.748 790.986 167.609 826.822"
        initial={{ pathLength: 0 }}
        animate={{ pathLength: animate ? 1 : 0 }}
        transition={{ duration: 0.1, delay: 0.8, ease: "easeInOut" }}
      />
      <motion.path
        d="M534.137 133.661L582.404 47.6196"
        initial={{ pathLength: 0 }}
        animate={{ pathLength: animate ? 1 : 0 }}
        transition={{ duration: 0.1, delay: 0.9, ease: "easeInOut" }}
      />
      <motion.path
        d="M584.5 572.259C607.912 594.37 631 616.66 653.752 639.413"
        initial={{ pathLength: 0 }}
        animate={{ pathLength: animate ? 1 : 0 }}
        transition={{ duration: 0.1, delay: 1, ease: "easeInOut" }}
      />
      <motion.path
        d="M7.39931 431.656C-19.3293 431.656 60.489 438.076 87.1445 440.05"
        initial={{ pathLength: 0 }}
        animate={{ pathLength: animate ? 1 : 0 }}
        transition={{ duration: 0.1, delay: 1.1, ease: "easeInOut" }}
      />
    </motion.svg>
  )
}
